import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "reactstrap";
import Select from "../common/Select/Select";

export const SelectHorosaisonnierStep = ({ value, onChange, ...props }) => {
  const { t } = useTranslation();

  const options = [
    { value: 1, label: t("global.step.yearly") },
    { value: 2, label: t("global.step.quarterly") },
    { value: 3, label: t("global.step.monthly") },
  ];

  return (
    <Label {...props}>
      <span className="mr-2 font-weight-bold">{t("global.step.label")}</span>

      <Select
        value={options.find((o) => o.value === value)}
        options={options}
        onChange={(option) => {
          if (option) onChange(option.value);
        }}
        width={200}
        fontSize={12}
        bordered
      />
    </Label>
  );
};
